import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { constants } from 'src/app/shared/common/contants';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

export interface functionalmappingdata{
  editData: any;
  uploadId:any;
}
@Component({
    selector: 'app-functional-mapping-popup',
    templateUrl: './functional-mapping-popup.component.html',
    styleUrls: ['./functional-mapping-popup.component.scss'],
    standalone: false
})
/**
   *@Author : Shyam
   * @Date :21-02-2025
   *@Note Functional Mapping component
   */
export class FunctionalMappingPopupComponent implements OnInit {

  backgroundColorButton;
  FormValid: UntypedFormGroup;
  updatedData;
  uploadId;
  name;
  validation_messages: any;
  functional={
    logic:'',
    mappingtype:'',
    objectfieldid:'',
    objectname:'',
    sql:'',
    vaultfieldpresence:'',
    vaultsubsection:'',
    veevauifield:'',
    veevauisection:''
  }

  constructor(private commonservice: CommonService, public dialogRef:MatDialogRef<FunctionalMappingPopupComponent>,private validation:validationmethod,private localstorage:LocalStorageSettingsService,
    private errormessage:ErrorMessages,private spinner: NgxUiLoaderService,private snackbar:MatSnackBar, @Inject(MAT_DIALOG_DATA) public data: functionalmappingdata, private constants:constants,private fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    console.log(this.data)
    console.log("This is the value of logic",this.data.editData.logic)
    this.updatedData = this.data.editData;

    this.functional.logic = this.data.editData.logic,
    console.log("logic", this.functional.logic)
    this.name=this.functional.logic
    this.functional.mappingtype = this.data.editData.mappingtype,
    this.functional.objectfieldid = this.data.editData.objectfieldid,
    this.functional.objectname = this.data.editData.objectname,
    this.functional.sql = this.data.editData.sql,
    this.functional.vaultfieldpresence = this.data.editData.vaultfieldpresence,
    this.functional.vaultsubsection = this.data.editData.vaultsubsection,
    this.functional.veevauifield = this.data.editData.veevauifield,
    this.functional.veevauisection = this.data.editData.veevauisection,

    console.log( "This functional type",typeof(this.functional))
    console.log("this is updated",typeof(this.updatedData))
    console.log("This is functinal",this.functional)
    console.log("This is updated",this.updatedData)
    this.uploadId = this.data.uploadId;
    this.backgroundColorButton = this.localstorage.getSettings('ColorA');
   
    this.formvalidations();
    this.FormValid.get('logic')?.setValue(this.functional.logic);
  }
  cancel(){
    this.dialogRef.close();
  }

  formvalidations(){
    this.FormValid = new UntypedFormGroup({
      logic : new UntypedFormControl('',[Validators.required])
    })
  }

  saveMethod(){
    console.log("Inside of save mehtod")
    this.functional.logic = this.FormValid.get('logic')?.value;
    console.log("Functional Logic Before Validation:", this.functional.logic);
    console.log("Form Validity:", this.FormValid.valid);
    console.log("Form Errors:", this.FormValid.get('logic')?.errors);
    console.log(this.updatedData.logic)
    console.log(this.updatedData.logic)
      // Compare the current state with the original state (data.editData)
  if (this.functional.logic.trim() === this.updatedData.logic.trim()) {
    console.log("No changes detected. Skipping API call.");
    this.snackbar.open("No changes made", "OK", { duration: 3000 });
    this.dialogRef.close();
    return;
  }
    if(!this.FormValid.valid || this.functional.logic ===""){
      this.snackbar.open("Please fill manditory field","ok",{duration:300});
      return
    }
    
    console.log(this.functional)
    const formdata = this.functional
    console.log('Saving Data:', formdata);
    console.log("sending uploadId",this.uploadId)
    this.commonservice.editFunctionalMapping(this.uploadId,formdata ).subscribe({
      next: (response) => {
        console.log('edit successful', response);
        console.log(response.data)
        // const transformedData = this.transformResponseData(response.data);
        // console.log('Transformed data:', transformedData);
        // this.gridApi.api.setGridOption('rowData', transformedData);
        this.updatedData = null;
        this.snackbar.open(' Updated successfully', 'OK', { duration: 3000 });
        this.dialogRef.close(response.data);
      },
      error: (error: any) => {
        console.error('retrieve failed', error);
        
      },
      complete: () => {
        console.log('retrieve  completed');
        this.updatedData = null
      }
    });
  }
}
